import { Box, Typography } from '@mui/material'
import { KWireInput } from './KWireInput'
import KWireList from './KWireList'
import type { KWiresProps } from './KWireTypes'
import './KWires.scss'

export function KWires({
  items = [],
  selectedItems = [],
  onAddItem = () => {},
  onRemoveItem = () => {},
}: KWiresProps) {
  return (
    <Box className="kwires-container">
      <Typography variant="h6" className="kwires-title">
        Other Items
      </Typography>

      <Box className="kwires-content">
        <KWireInput items={items} onAddItem={onAddItem} />
        <KWireList items={selectedItems} onRemoveItem={onRemoveItem} />
      </Box>
    </Box>
  )
}

export default KWires
